import React from 'react';
import PropTypes from 'prop-types';
import Anchor from "../../../dashboardNew/objects/Anchor";

export const PartnershipOverviewComponent = (props) => {

	return(
        <div className="col-xs-12 col-sm-6 col-lg-4 partners-card">
            <Anchor
                path={props.link}
                internal
                anchorClass="inner-card"
            >
                <div className="card-head">
                    <div className="logo-hold">
                        <img src={props.logo} alt="Company Logo" className='logo-img'/>
                    </div>
                </div>
                <div className="card-body">
                    <h3 className="heading-two">{props.header}</h3>
                    <p className="body-copy">{props.description}</p>
                </div>
            </Anchor>
        </div>
	);
};

PartnershipOverviewComponent.propTypes = {
	primaryColor: PropTypes.string,
	buttonTextColor: PropTypes.string,
	secondaryColor: PropTypes.string,
	logo: PropTypes.string,
	header: PropTypes.string,
	description: PropTypes.string,
	link: PropTypes.string
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/PartnershipOverviewComponent.js